import { useEffect, useState } from "react";
import { FilterMapping } from "../../features/searchpage/constants/filters.constants";
import "./multi-field-selection.scss";
import { isMobile } from "../../utils/globalUtilities";

const MultiFieldSelection = ({ fieldKey, items, toggleFilter, selectedFilters, index }: any) => {
  const [itemsSearched, setItemsSearched] = useState<any>(items);
  const [value, setValue] = useState<string>("");
  const [position, setPosition] = useState<any>({});

  const onChangeSearchEventHandler = (e: any) => {
    if (e && e.target.value) {
      let value = e.target.value;
      // value = value.trim();
      setValue(value);
    } else {
      setValue('');
    }
  }

  useEffect(() => {
    setItemsSearched(items);
  }, [items]);

  useEffect(() => {
    if (value && value.trim()) {
      let searchStr: string = value.trim();

      if (isNaN(+searchStr)) {
        // for string search
        let optionsListSearched = items.filter((item: any) => (item['name']).toLowerCase().includes(searchStr.toLowerCase()));
        setItemsSearched(optionsListSearched)
      } else {
        let optionsListSearched = items.filter((item: any) => {
          let str = (item['name']).toLowerCase();
          let strArray = str.split(/[ -]+/);
          let flag = false;
          strArray.forEach((element: any) => {
            if (element.startsWith(searchStr.toLowerCase())) {
              flag = true
            }
          });
          return flag;
        });
        setItemsSearched(optionsListSearched)
      }
    } else {
      let optionsListSearched = items.filter(_ => true);
      setItemsSearched(optionsListSearched)
    }
  }, [value]);

  const getSelectionClass = (item: any) => {
    let selectionClass = '';
    if (selectedFilters[FilterMapping[fieldKey]['apiKey']]?.length) {
      let isSelectedData = selectedFilters[FilterMapping[fieldKey]['apiKey']].find((data: any) => { return data.id == item.id });
      if (isSelectedData?.id) {
        selectionClass = 'selected';
      }
    };
    return selectionClass;
  }

  const getSelectionChecked = (item: any) => {
    let selection: boolean = false;
    if (selectedFilters[FilterMapping[fieldKey]['apiKey']]?.length) {
      let isSelectedData = selectedFilters[FilterMapping[fieldKey]['apiKey']].find((data: any) => data.id == item.id);
      if (isSelectedData?.id) {
        selection = true;
      }
    };
    return selection;
  }

  const onClickMultiFieldSelection = (e: any) => {
    if (isMobile()) {
      let x = e.clientX;
      const screenportWidth = window.innerWidth;
      const scrWidthDrop = 260;
      if (x + scrWidthDrop > screenportWidth) {
        setPosition({ left: "auto", right: 0 });
      }
      else if (x < scrWidthDrop / 2) {
        setPosition({ left: 0, right: "auto" });
      }
      else {
        setPosition({ left: x - scrWidthDrop / 2, right: "auto" });
      }
}
}

    return (
      <li key={`MultiField${fieldKey + index}`} className="dropdowns ui-filter-item multi-dropdowns">
        <a  className={`dropdown-toggle-2 cursor-pointer  ${selectedFilters[FilterMapping[fieldKey]['apiKey']]?.length ? 'active' : ''} `} onClick={(e) => { onClickMultiFieldSelection(e) }} >
          {FilterMapping[fieldKey]['label']}
        </a>
        <span className="dropdown-contents" style={{ left: position.left, right: position.right, width: "260px", }} >
          <span className="dropdown-search">
            <input value={value} type="search" placeholder="Search"
              onChange={(e) => {
                onChangeSearchEventHandler(e)
              }}
            />
          </span>
          <ul className="multi-dropdown-items">

            {itemsSearched.map((item: any, indexSearched: number) => (
              <li
                key={`MultiFieldSelection${indexSearched + item.id + item.name + fieldKey}`}
                onClick={() => toggleFilter(FilterMapping[fieldKey]['apiKey'], item)}
                className={getSelectionClass(item)}
              >
                 
               
                  {/* {
                  getSelectionChecked(item) ?
                    <input type="checkbox" checked />
                    : <input type="checkbox" />
                } */}
                  {
                    
                    <span className="checkbox-t1">
                                               
                                               <input type="checkbox" checked={getSelectionChecked(item)} onChange={e => { }} />
                                                <span className="checkmark"> </span>
                                                </span>
                  }

                
                <span>
                {item.name}
                {
                  item?.ordering ?
                  <span className="item-records">[{item.ordering.toLocaleString()}]</span>
                  :
                  ''
                }
                </span>
              </li>
            ))}
          </ul>
        </span>
      </li>
    );
  };
 
  export default MultiFieldSelection;
